import { CookiebotConfig } from '../models/cmx-cookiebot.config';

export class DefaultCookiebotConfig implements CookiebotConfig {
  widgetEnabled = false;
}

